import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedUser: null,
  userData: null,
  resolvedUserId: null
};

const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload || null;
    },
    clearSelectedUser: state => {
      state.selectedUser = null;
    },
    setUserData: (state, action) => {
      state.userData = action.payload || null;
    },
    clearUserData: state => {
      state.userData = null;
    },
    setResolvedUserId: (state, action) => {
      state.resolvedUserId = action.payload || null;
    },
    clearResolvedUserId: state => {
      state.resolvedUserId = null;
    }
  }
});

export const { setSelectedUser, clearSelectedUser, setUserData, clearUserData, setResolvedUserId, clearResolvedUserId } =
  userManagementSlice.actions;
export default userManagementSlice.reducer;
